/* ••[1]••••••••••••••••••••••••• spotlightVm.ts •••••••••••••••••••••••••••••• */

import { CustomElement } from "../../core/CustomElement";
import { Spotlight, validatedSpotlight } from "../../core/types/Spotlight";

import ko from "knockout";

export default class SpotlightDialogVm {
  $customElement: CustomElement;
  spotlight: KnockoutObservable<Spotlight>;
  backgroundImage =
    "https://www.oracle.com/webfolder/community/ccc/prod/images/backgrounds/spotlight.png";

  constructor($customElement: CustomElement) {
    this.$customElement = $customElement;
    this.spotlight = ko.observable({} as Spotlight);
  }

  public display(): boolean {
    return !!validatedSpotlight(this.spotlight());
  }
}
